// 代扣类型
export const WITHHOLD_TYPE = {
  WALLET: 1, // 网约钱包支付
  ALIPAY: 2, // 支付宝支付
  MIXED: 3, // 混合支付
}

// 解约标题
// 解约的时候不可能解除混合支付，都是分别解除网约和支付宝，所以不用提供枚举标题
export const UNBIND_TITLE = {
  [WITHHOLD_TYPE.WALLET]: '解除网约钱包支付',
  [WITHHOLD_TYPE.ALIPAY]: '解除支付宝支付',
}
